import { TextField as MuiTextField, TextFieldProps, Autocomplete, AutocompleteProps } from '@mui/material';

export interface AutocompleteOption {
  label: string;
  value: string;
}
export type ControllerAutocompleteProps<T> = Omit<
  TextFieldProps,
  'select' | 'onChange' | 'onFocus' | 'onKeyDown' | 'onPaste' | 'value' | 'focused'
> & {
  AutocompleteProps: Omit<AutocompleteProps<T, false, false, true>, 'getOptionLabel' | 'renderInput'>;
  errorText?: string;
  readOnlyDisabled?: boolean;
  readOnly?: boolean;
};

export const ControllerAutocomplete = function <T = AutocompleteOption | string>(
  props: ControllerAutocompleteProps<T>
) {
  const {
    AutocompleteProps,
    readOnly,
    readOnlyDisabled,
    errorText,
    helperText,
    inputProps,
    InputProps,
    InputLabelProps,
    defaultValue,
    ...textFieldProps
  } = props;

  return (
    <Autocomplete
      getOptionLabel={(option) => {
        // had to option to the right type
        const value = (option as unknown) as AutocompleteOption | string;
        return typeof value === 'string' ? value : value.label;
      }}
      sx={{ minWidth: 200 }}
      size={'medium'}
      {...AutocompleteProps}
      renderInput={(params) => {
        const {
          inputProps: inputPropsAc,
          InputProps: { ref: inputRef, endAdornment, ...InputPropsAc },
          InputLabelProps: InputLabelPropsAc,
          ...rootProps
        } = params;

        return (
          <MuiTextField
            {...rootProps}
            inputRef={inputRef}
            helperText={props.error && errorText ? errorText : helperText}
            InputLabelProps={{
              ...InputLabelPropsAc,
              className: readOnlyDisabled ? 'Mui-disabled' : undefined,
              ...InputLabelProps,
            }}
            inputProps={{
              ...inputPropsAc,
              // classes added here are merged into existing MUI classes
              className: readOnlyDisabled ? 'Mui-disabled' : undefined,
              ...inputProps,
            }}
            InputProps={{
              endAdornment,
              ...InputPropsAc,
              readOnly: readOnly || readOnlyDisabled,
              className: readOnlyDisabled ? 'Mui-disabled' : undefined,
              tabIndex: readOnlyDisabled ? -1 : undefined,
              ...InputProps,
              sx: { padding: 0 },
            }}
            {...textFieldProps}
          />
        );
      }}
    />
  );
};

ControllerAutocomplete.displayName = 'ControllerAutocomplete';
